import _ from 'lodash'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '../../stores'
import { fetchCourseSectionsThunk, IChapter, ICourse } from '../../stores/courses'

export const useSections = (courseId: string) => {
  const dispatch = useDispatch()
  const { isLoading, sections } = useSelector((state: RootState) => state.courses)

  useEffect(() => {
    if (!_.isEmpty(courseId) && (_.isEmpty(sections) || !_.isEqual(sections?.id, courseId))) {
      dispatch(fetchCourseSectionsThunk(courseId))
    }
  }, [courseId, sections, dispatch])

  const course: ICourse = _.omit(sections, 'chapters')
  const curriculum: IChapter[] = _.get(sections, 'chapters') ?? []
  return { isLoading, course, curriculum }
}
